'use client'

import {
  Input,
  InputWrapper,
  InputErrorMessage,
  Button,
  Stack
} from 'design-system'

import { BackToLoginButton } from 'src/components/user/back-to-login-button'
import { SingleSignOnButton } from 'src/components/user/single-sign-on-button'
import { Divider } from 'src/components/user/divider'

import { useRecoverPassword } from './use-recover-password'

const USER_INPUT_ID = 'user-input'
const USER_LABEL_ID = 'user-label'

export const RecoverPasswordForm = () => {
  const { register, handleSubmit, onSubmit, errors, isSubmitting } =
    useRecoverPassword()

  return (
    <form className="mt-8" onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label
          id={USER_LABEL_ID}
          htmlFor={USER_INPUT_ID}
          className="mb-2 block font-light">
          Username or Email
        </label>
        <InputWrapper hasError={!!errors.user}>
          <Input
            {...register('user', {
              required: 'Username or email is required'
            })}
            id={USER_INPUT_ID}
            aria-labelledby={USER_LABEL_ID}
            type="text"
            placeholder="Enter username or email here"
          />
        </InputWrapper>
        <InputErrorMessage error={errors.user} />
      </div>
      <Button
        fullWidth
        className="mb-4 mt-6"
        type="submit"
        disabled={isSubmitting}>
        {isSubmitting ? 'Submitting...' : 'Submit'}
      </Button>
      <Stack gap={4}>
        <Divider />
        <BackToLoginButton />
        <SingleSignOnButton />
      </Stack>
    </form>
  )
}
